import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import GoogleMapDunny from './GoogleMapsDunny';
import { useParams } from "react-router-dom";
import Select, { ActionMeta, MultiValue } from 'react-select'

interface ScheduleRoutes {
    orderManual: string;
    branchName: string;
    branchAddress: string;
    branchLatitude: number;
    branchLongitude: number;
    jobAddresses: JobAddress[]
}

interface JobAddress {
    orderManual: string;
    jobOrder: number;
    placeId: string;
    address: string;
    item: string;
    quantityType: string;
    scheduleType: string;
    scheduleDateFormatted: string;
    lat: number;
    lng: number;
    colourId: number;       //used to display a green, orange or red pin
}

interface JobPins {
    jobId: number;
    placeId: string;
    address: string;
    lat: number;
    lng: number;
    colourId: number;       //used to display a green, orange or red pin
    items: JobPinsItems[];
}

interface JobPinsItems {
    jobId: number;
    scheduleDateFormatted: string;
    item: string;
    quantityType: string;
    scheduleType: string;
}

type OptionsItem = {
    label: string,
    value: number
}

interface GenericList {
    id: number;
    name: string;
}

const AllocateMapDunnyData = (props: RouteComponentProps<{}>) => {
    const [pins, setPins] = React.useState<JobPins[]>([]);
    const [routes, setRoutes] = React.useState<ScheduleRoutes[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [truckOptions, setTruckOptions] = React.useState<OptionsItem[]>([]);
    const [selectedTrucks, setSelectedTrucks] = React.useState<OptionsItem[]>([]);
    const [itemOptions, setItemOptions] = React.useState<OptionsItem[]>([]);
    const [selectedItems, setSelectedItems] = React.useState<OptionsItem[]>([]);
    const [scheduleTypeOptions, setScheduleTypeOptions] = React.useState<GenericList[]>([]);
    const [scheduleTypeId, setScheduleTypeId] = React.useState(-1);
    const [showUnallocated, setShowUnallocated] = React.useState(true);
    const [refreshMap, setRefreshMap] = React.useState(false);
    const { scheduleDate } = useParams<{ scheduleDate: string}>();
    const { itemTypeGroupId } = useParams<{ itemTypeGroupId: string }>();

    React.useEffect(() => {
        getAllocateAddressesDunny();
    }, [scheduleDate, itemTypeGroupId]);
    

    const getAllocateAddressesDunny = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser(); 

        axios.get('api/Allocate/GetAddressFencingToiletForAllocating?SubId=' + user.sub + '&ScheduleDate=' + scheduleDate + '&ItemTypeGroupId=' + itemTypeGroupId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //unallocated jobs - show pins
            //var newpins: ScheduleRoutes[] = [];
            //var item: ScheduleRoutes = {
            //    orderManual: "Pins",
            //    branchName: "",
            //    branchAddress: "",
            //    branchLatitude: 0,
            //    branchLongitude: 0,
            //    jobAddresses: res.data.jobAddresses
            //};
            //newpins.push(item);
            setPins(res.data.jobAddresses);

            //allocated jobs - show route - routes will be blank at this stage
            var newroutes: ScheduleRoutes[] = [];
            setRoutes(newroutes);

            setTruckOptions(res.data.truckOptions);
            setItemOptions(res.data.itemOptions);
            setSelectedItems(res.data.itemOptions);
            setScheduleTypeOptions(res.data.scheduleTypeOptions);
            setLoading(false);
            setRefreshMap(true);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getAllocateAddressesDunnyFiltered = async (filterSelectedItems: OptionsItem[], filterSelectedTrucks: OptionsItem[], filterShowUnallocated: boolean, filterScheduleType: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var filter = {
            scheduleDate: scheduleDate,
            itemTypeGroupId: parseInt(itemTypeGroupId),
            selectedItems: filterSelectedItems,
            selectedTrucks: filterSelectedTrucks,
            showUnallocated: filterShowUnallocated,
            scheduleTypeId: filterScheduleType,
            subId: user.sub
        };

        axios.post('api/Allocate/GetFilteredAddressesForAllocating', filter, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //get unallocated jobs and show pins on map
            //var newpins: ScheduleRoutes[] = [];
            //var item: ScheduleRoutes = {
            //    orderManual: "Pins",
            //    branchName: "",
            //    branchAddress: "",
            //    branchLatitude: 0,
            //    branchLongitude: 0,
            //    jobAddresses: res.data.jobAddresses
            //};
            //newpins.push(item);
            setPins(res.data.jobAddresses);

            //allocated jobs - show route
            setRoutes(res.data.routes);

            setRefreshMap(!refreshMap);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleMultiItemChange = (selected: MultiValue<OptionsItem>, actionMeta: ActionMeta<OptionsItem>) => {
        var result = [...selected];
        setSelectedItems(result);
        getAllocateAddressesDunnyFiltered(result, selectedTrucks, showUnallocated, scheduleTypeId);
    }

    const handleMultiTruckChange = (selected: MultiValue<OptionsItem>, actionMeta: ActionMeta<OptionsItem>) => {
        var trucks = [...selected];
        setSelectedTrucks(trucks);
        getAllocateAddressesDunnyFiltered(selectedItems, trucks, showUnallocated, scheduleTypeId);
    }

    const handleShowUnallocatedChange = (e: any) => {
        setShowUnallocated(e.target.checked);
        getAllocateAddressesDunnyFiltered(selectedItems, selectedTrucks, e.target.checked, scheduleTypeId);
    }

    const handleScheduleTypeChange = (e: any) => {
        var value = e.target.value * 1;
        setScheduleTypeId(value);
        getAllocateAddressesDunnyFiltered(selectedItems, selectedTrucks, showUnallocated, value);
    }


    let map = <GoogleMapDunny pins={pins} routes={routes} refreshMap={refreshMap} />

    const renderDetails = (
        <div className="makeitflexrow"> 
            <div className="mapfiltersize">
                <h3>Google Map Filter/s</h3>
                <label className="input-group" htmlFor="itemId">
                    <span className="label label-small">Item</span>
                    <Select className="allocate-map-item--width" isMulti id="itemFilter" name="itemFilter" defaultValue={selectedItems} options={itemOptions} onChange={handleMultiItemChange} />
                </label> 
                <label className="input-group" htmlFor="truckFilterId">
                    <span className="label label-small">Truck</span>
                    <Select isMulti id="truckFilter" name="truckFilter" defaultValue={selectedTrucks} options={truckOptions} onChange={handleMultiTruckChange} />
                </label>
                <label className={selectedTrucks.length > 0 ? "input-group" : "hidden"} htmlFor="showUnallocated">
                    <span className="label label-small">Show Unallocated</span>
                    <input className="input" type="checkbox" name="showUnallocated" checked={showUnallocated} onChange={(e) => handleShowUnallocatedChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="scheduleTypeId">
                    <span className="label label-small">Schedule Type</span>
                    <select className="" id="scheduleTypeId" name="scheduleTypeId" value={scheduleTypeId} onChange={(e) => handleScheduleTypeChange(e)}>
                        <option defaultValue="-1" value={-1}></option>
                        {scheduleTypeOptions.map(type =>
                            <option key={type.id} value={type.id}>{type.name}</option>
                        )};
                    </select>
                </label>
            </div>
            <div className="mapsize">
                {map}
            </div>

        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );

};

export default AllocateMapDunnyData;